// Module
var code = `<customer-breadcrumbs mode="'GROUP'"></customer-breadcrumbs>
<customer-profile-header mode="'GROUP'"></customer-profile-header>
<section class="box">
  <sub-header header="'Assign to group'"></sub-header>

    <div class="alert">
      <p>
      Please note that in the "assign to" selector you can choose <strong>ONLY</strong> groups that contain
        <strong>ALL</strong> customers from the selected batch.<br />
        If you cannot find the group you are looking for, add the appropriate members to the group first.
      </p>
    </div>

    <form name="\$ctrl.form">

      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Assign to:</td>
          <td>
            <select
              required
              class="form-control"
              ng-model="\$ctrl.request.targetCustomerId"
              ng-options="c.id as c.effectiveName for c in \$ctrl.groupCustomers">
            </select>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-success"
          ng-click="\$ctrl.assign()"
          ng-disabled="\$ctrl.form.\$invalid">
          Assign
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/loans/assign/group-loans-assign.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;